import { type ComponentTypeDictionary } from "@newxsystems/types";
import { HeroBlock } from "../cms/components/blocks/HeroBlock/HeroBlock";
import { TextMediaBlock } from "../cms/components/blocks/TextMediaBlock/TextMediaBlock";
import { CallToActionBlock } from "../cms/components/blocks/CallToActionBlock/CallToActionBlock";
import { ImageListingBlock } from "../cms/components/blocks/ImageListingBlock/ImageListingBlock";
import { IconFeatureGridBlock } from "../cms/components/blocks/IconFeatureGridBlock/IconFeatureGridBlock";
import { TeamGridBlock } from "../cms/components/blocks/TeamGridBlock/TeamGridBlock";
import { AccordionBlock } from "../cms/components/blocks/AccordionBlock/AccordionBlock";
import { OfficeCardsBlock } from "../cms/components/blocks/OfficeCardsBlock/OfficeCardsBlock";
import { ContactMethodsBlock } from "../cms/components/blocks/ContactMethodsBlock/ContactMethodsBlock";
import { ContactMapEmbedBlock } from "../cms/components/blocks/ContactMapEmbedBlock/ContactMapEmbedBlock";
import { BreadcrumbBlock } from "../cms/components/blocks/BreadcrumbBlock/BreadcrumbBlock";
import { FullWidthVideoFeatureBlock } from "../cms/components/blocks/FullWidthVideoFeatureBlock/FullWidthVideoFeatureBlock";
import { ImageGridBlock } from "../cms/components/blocks/ImageGridBlock/ImageGridBlock";
import { MasonryGalleryBlock } from "../cms/components/blocks/MasonryGalleryBlock/MasonryGalleryBlock";
import { ImageCarouselBlock } from "../cms/components/blocks/ImageCarouselBlock/ImageCarouselBlock";
import { TestimonialGridBlock } from "../cms/components/blocks/TestimonialGridBlock/TestimonialGridBlock";
import { FeaturedTestimonialBlock } from "../cms/components/blocks/FeaturedTestimonialBlock/FeaturedTestimonialBlock";
import { LogoProofBlock } from "../cms/components/blocks/LogoProofBlock/LogoProofBlock";
import { PageCardsBlock } from "../cms/components/blocks/PageCardsBlock/PageCardsBlock";
import { ResourceHighlightBlock } from "../cms/components/blocks/ResourceHighlightBlock/ResourceHighlightBlock";
import { FooterBlock } from "../cms/components/blocks/FooterBlock/FooterBlock";
import { MegaMenuBlock } from "../cms/components/blocks/MegaMenuBlock/MegaMenuBlock";
import { WysiwygBlock } from "../cms/components/blocks/WysiwygBlock/WysiwygBlock";
import { BackgroundContainerBlock } from "../cms/components/blocks/BackgroundContainerBlock/BackgroundContainerBlock";
import { LatestBlogPostsBlock } from "../cms/components/blocks/LatestBlogPostsBlock/LatestBlogPostsBlock";
import { FeaturedBlogPostsBlock } from "../cms/components/blocks/FeaturedBlogPostsBlock/FeaturedBlogPostsBlock";
import { BlogListingBlock } from "../cms/components/blocks/BlogListingBlock/BlogListingBlock";
import { NotFoundBlock } from "../cms/components/blocks/NotFoundBlock/NotFoundBlock";
// IMPORT COMPONENTS HERE

export const BlocksFactory: ComponentTypeDictionary = [
  {
    type: "hero",
    component: HeroBlock,
  },
  {
    type: "textMedia",
    component: TextMediaBlock,
  },
  {
    type: "callToAction",
    component: CallToActionBlock,
  },
  {
    type: "imageListing",
    component: ImageListingBlock,
  },
  {
    type: "iconFeatureGrid",
    component: IconFeatureGridBlock,
  },
  {
    type: "teamGrid",
    component: TeamGridBlock,
  },
  {
    type: "accordion",
    component: AccordionBlock,
  },
  {
    type: "officeCards",
    component: OfficeCardsBlock,
  },
  {
    type: "contactMethods",
    component: ContactMethodsBlock,
  },
  {
    type: "contactMapEmbed",
    component: ContactMapEmbedBlock,
  },
  {
    type: "breadcrumb",
    component: BreadcrumbBlock,
  },
  {
    type: "fullWidthVideoFeature",
    component: FullWidthVideoFeatureBlock,
  },
  {
    type: "imageGrid",
    component: ImageGridBlock,
  },
  {
    type: "masonryGallery",
    component: MasonryGalleryBlock,
  },
  {
    type: "imageCarousel",
    component: ImageCarouselBlock,
  },
  {
    type: "testimonialGrid",
    component: TestimonialGridBlock,
  },
  {
    type: "featuredTestimonial",
    component: FeaturedTestimonialBlock,
  },
  {
    type: "logoProof",
    component: LogoProofBlock,
  },
  {
    type: "pageCards",
    component: PageCardsBlock,
  },
  {
    type: "resourceHighlight",
    component: ResourceHighlightBlock,
  },
  {
    type: "footer",
    component: FooterBlock,
  },
  {
    type: "megaMenu",
    component: MegaMenuBlock,
  },
  {
    type: "wysiwyg",
    component: WysiwygBlock,
  },
  {
    type: "backgroundContainer",
    component: BackgroundContainerBlock,
    flags: { isLayout: true, layoutProperties: ["components"] },
  },
  {
    type: "latestBlogPosts",
    component: LatestBlogPostsBlock,
  },
  {
    type: "featuredBlogPosts",
    component: FeaturedBlogPostsBlock,
  },
  {
    type: "blogListing",
    component: BlogListingBlock,
  },
  {
    type: "NotFound",
    component: NotFoundBlock,
  },
  // DECLARE COMPONENTS HERE
];
